/** Canal `BroadcastChannel` partagé par les onglets de l'application. */
export const AUTH_TAB_SYNC_CHANNEL_NAME = 'pu-auth-session';

/**
 * Clé localStorage du repli par événement `storage` (navigateurs sans
 * BroadcastChannel) : le message y est écrit puis effacé aussitôt, l'écriture
 * suffisant à le diffuser aux autres onglets.
 */
export const AUTH_TAB_SYNC_FALLBACK_STORAGE_KEY = 'pu-auth-session-message';

/**
 * Attente maximale, au démarrage d'un onglet sans jeton, de la réponse d'un
 * onglet déjà connecté. Les gardes de route ne décident qu'ensuite ; sans
 * réponse dans ce délai, l'onglet démarre déconnecté.
 */
export const AUTH_TAB_SYNC_REPLY_TIMEOUT_MS = 200;

/** Taille (en octets aléatoires) de l'identifiant d'une demande de session. */
export const AUTH_TAB_SYNC_REQUEST_ID_BYTES = 16;
